const isDev = process.env.NODE_ENV !== 'production';

export const BASE_URL = isDev ? 'http://127.0.0.1:8000' : process.env.REACT_APP_BASE_URL;
export const API_PREFIX = process.env.REACT_APP_API_PREFIX || '/api/v1';
export const ADMIN_API_PREFIX = process.env.REACT_APP_ADMIN_API_PREFIX || '/admin-api/v1';
